import React from 'react';
import { Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Alert, Stack } from '@mui/material';
import SubmissionItem from './SubmissionItem';

/**
 * 提交历史面板组件
 * 显示所有提交记录
 */
function SubmissionsPanel({ submissions = [], latestResult = null }) {
  if (submissions.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h4" color="text.disabled" fontWeight="300">
          No data
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          You haven't submitted any solutions yet
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Typography variant="subtitle2" fontWeight="bold" gutterBottom sx={{ mb: 2 }}>
        Submission History ({submissions.length})
      </Typography>

      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell width="140">
                <strong>Status</strong>
              </TableCell>
              <TableCell align="center" width="100">
                <strong>Score</strong>
              </TableCell>
              <TableCell align="center" width="120">
                <strong>Tests</strong>
              </TableCell>
              <TableCell width="150">
                <strong>Submitted</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {submissions.map((sub, index) => (
              <SubmissionItem
                key={sub.id}
                submission={sub}
                isLatest={index === 0}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Latest submission detail */}
      {latestResult && (
        <Alert
          severity={latestResult.status === 'passed' ? 'success' : 'error'}
          sx={{ mt: 3 }}
        >
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Latest Submission
          </Typography>
          <Stack spacing={0.5}>
            <Typography variant="body2">
              Status:{' '}
              <strong>
                {latestResult.status === 'passed' ? 'Accepted ✅' : 'Wrong Answer ❌'}
              </strong>
            </Typography>
            <Typography variant="body2">
              Final Score: <strong>{latestResult.score}/100</strong>
            </Typography>
            {latestResult.testResults && (
              <Typography variant="body2">
                All Tests: {latestResult.testResults.passed}/{latestResult.testResults.attempted}{' '}
                passed (includes secret tests)
              </Typography>
            )}
            {latestResult.errorMessage && (
              <Typography variant="caption" color="error.main" sx={{ display: 'block', mt: 1 }}>
                {latestResult.errorMessage}
              </Typography>
            )}
          </Stack>
        </Alert>
      )}
    </Box>
  );
}

export default SubmissionsPanel;

